import { Button, Modal } from 'antd';
import {
  getChannelIdByCode,
  saveContactResponseToSession
} from 'components/omni-channel-chat/OmniChatSessionsProcessing';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { useGetShiftMeActive, useInterceptAIChatSession, useProfile } from 'hooks';
import { aiAgentCenterMessages, messages } from 'messages';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from 'routes/constants';
import { useCreateContactEventMutation } from 'services/tickets';
import { ChatSessionDto } from 'types';

type Props = {
  chatSession: ChatSessionDto;
  chatSessionId?: number;
};

const AIAgentChatIntervention: React.FC<Props> = ({ chatSession, chatSessionId }) => {
  const navigate = useNavigate();

  const { profile } = useProfile();
  const { shiftMeActive } = useGetShiftMeActive();
  const [onCreateContactEvent] = useCreateContactEventMutation();

  const { setChatSession } = useAIAgentCenterContext();

  const { onInterceptChatSession, isLoading } = useInterceptAIChatSession();

  const handleIntervention = () => {
    Modal.confirm({
      title: aiAgentCenterMessages.interventionChat,
      content: aiAgentCenterMessages.interventionChatWarning,
      okText: messages.confirmButtonText,
      cancelText: messages.cancelButtonText,
      onOk: () => {
        if (chatSessionId) {
          onInterceptChatSession(chatSessionId, (data) => {
            if (data.chatSessionId) {
              navigateSupportCustomer(data.chatSessionId);
            }
            setChatSession(null);
          });
        }
      },
      okButtonProps: {
        loading: isLoading
      }
    });
  };

  const onCreateContactEventHandle = () => {
    const findSession = chatSession;
    const channelId = getChannelIdByCode(findSession?.chat?.source);
    if (profile?.extensionId && profile?.username && shiftMeActive?.shiftId && channelId) {
      onCreateContactEvent({
        agentId: profile?.userId,
        agentName: profile?.username,
        channelId: channelId,
        contactAccount: findSession?.chat?.customerId,
        contactId: findSession?.chat?.pageId,
        flowCode: 'Chat',
        shiftId: shiftMeActive?.shiftId,
        chatSessionId: findSession?.chatSessionId
      })
        .unwrap()
        .then((response) => {
          // Save response to session data
          const chatSessionId = findSession?.chatSessionId;
          saveContactResponseToSession(chatSessionId, response);
        })
        .catch((error) => {
          console.error('❌ Failed to create contact event:', error);
        });
    }
  };

  const navigateSupportCustomer = (chatSessionId: number) => {
    onCreateContactEventHandle();
    navigate(ROUTE.CUSTOMER_LOOKUP, {
      state: {
        chatAISessionId: chatSessionId
      }
    });
  };

  return (
    <>
      <Button
        loading={isLoading}
        className='h-10 w-[105px] font-semibold'
        danger
        onClick={() => {
          handleIntervention();
        }}
      >
        {aiAgentCenterMessages.intervention}
      </Button>
    </>
  );
};
export default AIAgentChatIntervention;
